var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cursor-pointer"},[(
			_vm.onePs.urls_displayed == 'loading' ||
			_vm.onePs.google_indexable_urls == 'loading'
		)?_c('div',[_c('div',{staticClass:"sloader"})]):_c('div',[_vm._v("\n\t\t"+_vm._s(Number(_vm.onePs.google_indexable_urls) == 0 ||
			Number(_vm.onePs.urls_displayed) == 0
				? 0
				: Math.floor(
						(Number(_vm.onePs.google_indexable_urls) /
							Number(_vm.onePs.urls_displayed)) *
							100
				  ) || 0)+"\n\t\t%\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }